import { render, staticRenderFns } from "./layout.html?vue&type=template&id=87d0c482&scoped=true&"
import script from "./layout.ts?vue&type=script&lang=js&"
export * from "./layout.ts?vue&type=script&lang=js&"
import style0 from "./layout.scss?vue&type=style&index=0&id=87d0c482&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d0c482",
  null
  
)

export default component.exports